import React from "react";

import ShareButtonWrapper from "./shareButtonWrapper";
import { ReactComponent as TwitterIcon } from "../../../semantic/assets/images/share/twitter.svg";

const TwitterShare = (props) => {
  const text = props.text ? props.text : "";
  const classNames = props.classNames ? props.classNames : "";

  const getDefaultShareText = () => {
    if (props.defaultShareText) {
      return props.defaultShareText.replace(/{Link}/g, props.url);
    }
    return props.url;
  };

  const url = `https://twitter.com/intent/tweet/?text=${getDefaultShareText()}`;

  return (
    <ShareButtonWrapper url={url} onClick={props.onClick}>
      <div className={classNames}>
        {props.children}
        {!props.children && (
          <div>
            <TwitterIcon />
            {text}
          </div>
        )}
      </div>
    </ShareButtonWrapper>
  );
};

export default TwitterShare;
